import type { ReactNode } from 'react';

import { Tooltip } from '../../core/slots/Tooltip.js';
import { DISPLAY_NAME } from '../constants/defaults.js';
import { XYChartTooltipPayload } from '../types/xy-chart.js';

export const XYChartTooltipSlot = Tooltip<{
  hidden?: boolean;
  children?: (tooltipPayload: XYChartTooltipPayload) => ReactNode;
}>(DISPLAY_NAME);
